import BaseCell from "../../sisu/chart/BaseCell.sisu";

const NeoCell = BaseCell

export default NeoCell;